import { createContext, useState } from 'react';
import api from 'services/api';

export const ExposicaoFeiraContext = createContext();

export const ExposicaoFeiraProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [exposicaoFeira, setExposicaoFeira] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getExposicaoFeira = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: exposicaoFeira?.filter,
        page: exposicaoFeira?.page,
        size: exposicaoFeira?.size,
        order: exposicaoFeira?.order,
        ...payload,
      });
      setExposicaoFeira((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ExposicaoFeiraContext.Provider
      value={{
        exposicaoFeira,
        getLoading,
        getExposicaoFeira,
      }}
    >
      {children}
    </ExposicaoFeiraContext.Provider>
  );
};
